export default "__VITE_ASSET__CcJwO7ql__"